import { useEffect, useRef, useState } from "react";

// Reliable replacement for recharts <ResponsiveContainer> which renders blank
// under React 19 + recharts 3.x. Measures its own width and passes explicit
// numeric dimensions to the chart via render-prop.
export default function ChartBox({ height = 280, children }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => setWidth(el.clientWidth);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ width: "100%", height }}>
      {width > 0 ? children(width, height) : null}
    </div>
  );
}
